const ABProcessTriggerCore = require("../../../core/process/tasks/ABProcessTriggerCore");
module.exports = class ABProcessTrigger extends ABProcessTriggerCore {};
